import React from 'react';
import f1 from '../img/flor1.jpeg';
import f2 from '../img/flor2.jpeg';
import f3 from '../img/flor3.jpeg';
import f4 from '../img/flor4.jpeg';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from 'react-router-dom';
import  {Title,Div, Click, Span, Img} from './StyleComponents';



const Flotante = () => {
	return (
		<>
			<Link className='flecha' to={'/'}>
				&#60;{' '}
			</Link>
			<Click>(Precio válido por fotografía de dos personas)</Click>
			<Title>Flotante negro</Title>

			<AliceCarousel
				disableButtonsControls
				controlsStrategy='alternate responsive'
			>
				<Img src={f1} className='sliderimg' />
				<Img src={f2} className='sliderimg' />
				<Img src={f3} className='sliderimg' />
				<Img src={f4} className='sliderimg' />
			</AliceCarousel>
			<Div>
				
				<Title>
					28 <Span>x</Span> 23 cm{' '}
				</Title>
				<Title>
				<Span>Con ilustración</Span> $45000 <br></br>
				<Span>Con fotografía</Span> $35000 <br></br>
				</Title>
			</Div>
	
		</>
	);
};

export default Flotante;
